import { GenericMoleculeOverviewRowPanelDashboardComponent } from '../abstract';

// tslint:disable-next-line:max-line-length
export class MoleculeOverviewRowPanelDashboardMailboxesComponent extends GenericMoleculeOverviewRowPanelDashboardComponent {
    public template = require('./dashboard-mailboxes.html');
    protected type = 'mailboxes';
}
